'use strict';

window.TAXA_M2_HA = 10000;
window.TAXA_GRAMAS_KG = 1000;

angular.module('webAgro1App').factory('CalculationService', function() {

  return {
    getVariation: function(valueA, valueB) {
      return (valueA > 0) ? (((valueB / valueA) - 1) * 100).toFixed(2) : 0;
    },

    convertM2ForHa: function(value) {
      return (value > 0) ? (value / TAXA_M2_HA) : 0;
    }
  };
});
